import { useEffect } from "react";

/**
 * Hook to prefetch external pages that will be loaded in iframes
 * @param url The URL to prefetch
 */
export function usePrefetch(url: string) {
  useEffect(() => {
    // Create a link element for prefetching
    const linkElement = document.createElement("link");
    linkElement.rel = "prefetch";
    linkElement.href = url;
    linkElement.as = "document";

    // Add the link to the document head
    document.head.appendChild(linkElement);

    // Clean up the link element when the component unmounts
    return () => {
      document.head.removeChild(linkElement);
    };
  }, [url]);
}
